export const CALL_API = 'middleware/CALL_API';

export const capiCreator = (
  requestType: string,
  successType: string,
  failType: string,
  axios: () => Promise<any>,
  payload?: any,
  shouldCall?: () => boolean
) => ({
  type: CALL_API,
  types: [ requestType, successType, failType ],
  callAPI: axios,
  payload: payload,
  shouldCallAPI: shouldCall
});




// WEBPACK FOOTER //
// ../../src/redux/CallApiMiddlewareActionCreator.ts